import React, { useState } from "react";
import { DescriptionContent, Image, SectionContainer, Title } from "./styles";
import image from "../../assets/suggestion.png";
import { Button } from "../../styles";
import { RiArrowRightLine } from "react-icons/ri";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

const Suggestion = () => {
  const [api, setApi] = useState<string>("");
  const [suggestion, setSuggestion] = useState<string>("");

  const handleChange = (event: SelectChangeEvent) => {
    setApi(event.target.value as string);
  };

  const handleChangeTextArea = (event: any) => {
    setSuggestion(event.target.value);
  };

  return (
    <SectionContainer>
      <DescriptionContent>
        <Title>Colabore conosco, mande sua sugestão</Title>
        <FormControl fullWidth style={{ marginBottom: "1.75rem" }}>
          <InputLabel id="demo-simple-select-label">API</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={api}
            onChange={handleChange}
            label="API"
            placeholder="Selecione uma das opções"
          >
            <MenuItem value={10}>Ten</MenuItem>
            <MenuItem value={20}>Twenty</MenuItem>
            <MenuItem value={30}>Thirty</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth style={{ marginBottom: "1.75rem" }}>
          <TextField
            id="outlined-multiline-static"
            label="Sugestão"
            placeholder="Escreva sua sugestão aqui..."
            multiline
            rows={4}
            value={suggestion}
            onChange={handleChangeTextArea}
          />
        </FormControl>
        <Button style={{ padding: "0.75rem 5.875rem", marginLeft: 0 }}>
          Enviar
          <RiArrowRightLine color="#ffffff" />
        </Button>
      </DescriptionContent>
      <Image alt="imagem" src={image} />
    </SectionContainer>
  );
};

export default Suggestion;
